export const FETCH_LOI_LIST_REQUEST =
    'FETCH_LOI_LIST_REQUEST';
export const FETCH_LOI_LIST_SUCCESS =
    'FETCH_LOI_LIST_SUCCESS';
export const FETCH_LOI_LIST_FAILURE =
    'FETCH_LOI_LIST_FAILURE';


export const DELETE_LOI_REQUEST = 'DELETE_LOI_REQUEST';
export const DELETE_LOI_SUCCESS = 'DELETE_LOI_SUCCESS';
export const DELETE_LOI_FAILURE = 'DELETE_LOI_FAILURE';
export const UPDATE_LOI_REQUEST = 'UPDATE_LOI_REQUEST';
export const UPDATE_LOI_SUCCESS = 'UPDATE_LOI_SUCCESS';
export const UPDATE_LOI_FAILURE = 'UPDATE_LOI_FAILURE';
export const CREATE_LOI_REQUEST = 'CREATE_LOI_REQUEST';
export const CREATE_LOI_SUCCESS = 'CREATE_LOI_SUCCESS';
export const CREATE_LOI_FAILURE = 'CREATE_LOI_FAILURE';